export const NO_RECORD_FOUND = "NO RECORD FOUND";

export enum MessageType {
  RELOAD_MESSAGE = "RELOAD_MESSAGE",
  NEW_VERSION_HEADER = "NEW_VERSION_HEADER",
  DOCUMENT_DOWNLOAD_ERROR = "DOCUMENT_DOWNLOAD_ERROR",
  UNAUTHORIZED_MESSAGE = "UNAUTHORIZED_MESSAGE",
  UNAUTHORIZED_ERROR_HEADER = "UNAUTHORIZED_ERROR_HEADER",
}

export const ResponseMessages = (value: string) => {
  switch (value) {
    case MessageType.RELOAD_MESSAGE:
      return "Please reload to continue with the latest version.";
    case MessageType.NEW_VERSION_HEADER:
      return "New Version Available";
    case MessageType.DOCUMENT_DOWNLOAD_ERROR:
      return "Document Download Error!";
    case MessageType.UNAUTHORIZED_MESSAGE:
      return "Your session has expired.";
    case MessageType.UNAUTHORIZED_ERROR_HEADER:
      return "Unauthorized Access";
    default:
      return "";
  }
};